export * from './lib/components/registration-warranty-note-panel/registration-warranty-note-panel.component';
